import { createTheme } from "@mui/material/styles";

const Palette = () => {
  return createTheme({
    palette: {
      background: {
        default: "#f8f9fe",
      },
      common: {
        black: "#000000",
        white: "#FFFFFF",
      },
      text: {
        primary: "#272727",
        primary40: "#27272766",
        primary50: "#21212080",
        primary60: "#27272799",
        primary80: "#272727CC",
        secondary: "#001823",
        white60: "#FFFFFF99",
      },
      custom: {
        primary: "#284476",
        secondary: "#fab81d",
        mainColor: "#f8f9fe",
        darkColor: "#272727",
        borderColor: "#2727271A",
      },
    },
  });
};

export default Palette;
